// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"203":"f780793e","622":"319b0912","737":"c78a2fb7","860":"161eee4a"}[chunkId] + ".css";
};